<template>
  <div
    style="
      width: calc(var(--unit-case) * 1);
      height: calc(var(--unit-case) * 1);
      font-size:10px
    "
    class="b-fs b-c"
    :data-case-id="id"
  ></div>
</template>

<script>
export default {
  name: 'CaseWidget',
  props: {
    id: Number
  }
}
</script>
